var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("banner"),_c('div',{staticStyle:{"padding":"5% 1em","max-width":"1000px","margin":"auto"}},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }